import { Roles } from "@/models/user/roles";

export type GlobalState = {
  isLoading: boolean;
  isLoggedIn: boolean;
  isMobile: boolean;
  isTablet: boolean;
  userRole: Roles | null;
  multiplier: number;
};

export type GlobalContext = {
  state: GlobalState;
  dispatch: (action: GlobalActions, payload?: any) => any;
  commit: (mutation: GlobalMutations, payload: any) => any;
};

export enum GlobalMutations {
  SetLoading = "setLoading",
  SetLoggedIn = "setLoggedIn",
  SetMobile = "setMobile",
  SetTablet = "setTablet",
  SetRole = "setRole",
  SetMultiplier = "setMultiplier"
}

export enum GlobalActions {
  AddLoading = "addLoading",
  AddLoggedIn = "addLoggedIn",
  AddMobile = "addMobile",
  AddTablet = "addTablet",
  AddRole = "addRole",
  AddMultiplier = "addMultiplier"
}

export enum GlobalGetters {
  GetLoading = "getLoading",
  GetLoggedIn = "getLoggedIn",
  GetMobile = "getMobile",
  GetTablet = "getTablet",
  GetRole = "getRole",
  GetMultiplier = "getMultiplier"
}
